import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

export default function AdminLogin() {
    const [credentials, setCredentials] = useState({ id: '', password: '' });
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setCredentials({...credentials, [e.target.name]: e.target.value});
        if (error) setError(false); // Reset error when typing
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Mocking the Backend Auth securely for Step 1
        // (In Step 2 this will route through Axios to `https://smsapi.euisc.com/v1/auth/login`)
        if(credentials.id === 'admin' && credentials.password === 'admin123') {
            // Success! Store a mock secure token
            localStorage.setItem('adminToken', 'mock_jwt_secure_token_abc123');
            navigate('/admin/gallery'); 
        } else {
            setError(true);
        }
    }

    return (
        <div className="admin-login-container">
            <div className="login-card">
                <div className="login-icon">🔒</div>
                <h2>Admin Portal</h2>
                <p>Welcome back. Please authenticate to continue.</p>
                
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label>Admin ID</label>
                        <input 
                            type="text" 
                            name="id" 
                            value={credentials.id} 
                            onChange={handleChange} 
                            placeholder="e.g., admin" 
                            required 
                        />
                    </div>
                    <div className="input-group">
                        <label>Password</label>
                        <input 
                            type="password" 
                            name="password" 
                            value={credentials.password} 
                            onChange={handleChange} 
                            placeholder="••••••••" 
                            required 
                        />
                    </div>
                    
                    {error && <p className="error-text">❌ Invalid credentials. Please try again.</p>}
                    
                    <button type="submit" className="login-btn">Secure Login</button>
                </form>
            </div>
        </div>
    );
}
